<template>
    <v-dialog v-model="dialog" scrollable max-width="400px" hide-overlay>
        <template v-slot:activator="{ on }">
            <v-btn color="secondary" small icon v-on="on">
                <v-tooltip bottom color="primary">
                    <template v-slot:activator="{ on }">
                        <v-icon small v-on="on">mdi-pencil</v-icon>
                    </template>
                    <span>edit team</span>
                </v-tooltip>
            </v-btn>
        </template>
        <v-card v-if="!loading">
            <v-card-title class="subtitle-2 pt-6">
                New team  name
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="black--text">
                <v-container grid-list-md>
                    <v-form v-model="valid" ref="form" validation>
                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <v-text-field dense color="primary"
                                    label="Team name" 
                                    v-model="name" name="name"
                                    type="text" :rules="[rules.required]">
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
                <v-row justify="center" class="error">{{ error }}</v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text class="text-capitalize" @click="closeDialog">
                    Close
                </v-btn>
                <v-btn color="primary" text class="text-capitalize" :disabled="!valid || Boolean(error)"
                    @click="editTeam">Edit</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

export default {
    name: 'Edit_Team',
    props: ['team'],
    data() {
        return {
            dialog: false,
            valid: false,
            error: '',
            rules: {
                required: v => !!v || 'this field is required',
            },
            name: '',
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
    },
    methods: {

        onceMore() {
            this.error = ''
        },
        async editTeam() {

            if (this.$refs.form.validate()) {
                const team = {
                    gameId: this.set.value,
                    name: this.name,
                }

                try {
                    //edit team
                    await this.$store.dispatch('editTeam', team)
                    this.closeDialog()
                }
                catch (error) {
                    this.$store.dispatch('setError', error.message)//throw error
                }
            }
        },
        closeDialog() {
            //reset
            this.dialog = false;
            this.error = '';
            this.name = '';
        }
    },
}
</script>
